
import { Component, Vue, Prop } from 'vue-property-decorator';
import ChatContent from '@/components/chat/chatContent.vue';
import ChatInput from '@/components/chat/chatInput.vue';
import ChatInfo from '@/components/chat/chatInfo.vue';
import { Dialog, Toast } from 'vant';
import { group, GroupMessage, responsePayload, user, groupUser } from '@/interfaces/websocketMessageInterfaces';
import i18n from '@/lang';
import { watch } from 'vue';
import { shieldFriend } from '@/apis/Instantmessaging';
import { ensureImLogin } from '@/apis/message/message';
type avatarUrl = string;

@Component({
  components: {
    ChatContent,
    ChatInput,
    ChatInfo,
  },
})
export default class Chat extends Vue {
  private groupId: string | (string | null)[] = '';
  private friendid: string | (string | null)[] = '';
  private name = '';
  private className = 'testClassName';
  private messageData: Array<GroupMessage> = [];
  private groupInfo!: group;
  private userList: Array<user> = [];
  private checkSendStatusTimer:any=  null;
  private imLoading:boolean = false;
  private moreSheeShow:boolean = false;
  private userMute:number      = 0;
  private firendUser:any       = {};

  private moreActions: any = [
    { name: "历史记录", type:'history'},
    //{ name: this.userMute==0?"拉黑":'解除拉黑',  type:'shield'},
  ];

  created(){
    this.imLoading = false;
    this.checkSendMsgStatusTimerFun();
  }

  onMoreActionSelect(item: any, index: any){
    if(item.type == 'history'){
      this.$router.push({ path: '/ChatHistory', query: { friendid: this.friendid } });
    }else if(item.type == 'shield'){
      if(this.userMute == 0){
        this.$dialog.confirm({
          title: '系统提示',
          message: '确定拉黑该好友吗？',
          beforeClose: (action, done) => {
            if (action === 'confirm') {
              //@ts-ignore
              shieldFriend({groupid:this.groupInfo.id,friendid:this.firendUser.uid,mute:1}).then((res:any)=>{
                this.userMute = 1;
                this.moreSheeShow = false;
                Toast('已经成功拉黑');
                this.$forceUpdate();
                done();
                location.reload();
              });
            }
          }
        });
      }else if(this.userMute == 1){
        this.$dialog.confirm({
          title: '系统提示',
          message: '是否要解除拉黑该好友？',
          beforeClose: (action, done) => {
            if (action === 'confirm') {
              //@ts-ignore
              shieldFriend({groupid:this.groupInfo.id,friendid:this.firendUser.uid,mute:0}).then((res:any)=>{
                this.userMute = 1;
                this.moreSheeShow = false;
                Toast('已经成功解除拉黑');
                this.$forceUpdate();
                done();
                location.reload();
              });
            }
          }
        });
      }
    }
  }

  mounted() {
    this.$router.onReady(async () => {
      this.groupId   = this.$route.query.groupId;
      this.friendid  = this.$route.query.friendid;
      this.imLoading = true;
      if (!this.groupId) {
        this.imLoading = false;
        Dialog.alert({
          title: 'error',
          message: i18n.t('message.获取用户组失败组id为空') as string,
          showCancelButton: false,
          beforeClose: () => {
            this.$router.back();
          },
        });
        return;
      }
      const loginParam = await ensureImLogin(this.wsMsgModule);
      if (!loginParam) {
        this.imLoading = false;
        Toast(i18n.t('CommonComponents.连接失败') as string);
        return;
      }
      setTimeout(() => {
        this.setWebSocketFunction();
      }, 200);
    });
  }

  setWebSocketFunction() {
    this.imLoading = true;
    this.wsMsgModule.getGroupMessage({
      groupId: Number(this.groupId),
      pageSize: window.wsIMModule.loginParam?.pageSize || 50,
    });

    this.wsMsgModule.getGroupUserList({
      groupId: Number(this.groupId),
    });

    this.wsMsgModule.onGetGroupMessage = (param: any) => {
      if (param.data.length) {
        this.messageData  = param.data.reverse(); // 兼容涛哥的数据错误，现在是按照日期倒着排序的，前端这里给正过来
        const lastMessage = this.messageData[this.messageData.length - 1];
        this.setAlreadyRead(lastMessage.groupId, lastMessage.id);
      }
      this.$forceUpdate();
    };

    this.wsMsgModule.onGetGroupUserList = (param: any) => {
      this.groupInfo  = param.groupInfo;
      this.name       = this.groupInfo.name;
      this.userList   = param.userList;
      //@ts-ignore
      this.firendUser = this.userList[1];
      this.userMute   = this.firendUser['mute'];
      this.$forceUpdate();
      this.$setNavInfo({
        type: 'split',
        title: `<span class="common_mgr16">${this.name}</span><span class="font-color--info font12" style="line-height: 21px;">${ this.$route.query.coursename || '' }</span>`,
        btnGroup: [
          {
            type: 'icon',
            iconClassName: 'icon-more_outline',
            callback: () => {
              this.moreSheeShow = true
            },
          }
        ],
      });
      this.imLoading = false;
      setTimeout(() => {
        this.scrollToBottom();
      }, 1000);
    };

    /**
     * 返回消息的
     */
    this.wsMsgModule.onGetMessage = (param: any) => {
      const { groupId, id } = param;
      this.setAlreadyRead(groupId, id);
      this.messageData.push(param);
      this.$forceUpdate();
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    };

    //发送消息时的回执
    this.wsMsgModule.onSendResponeUniqueCode = (uniqueCode: number,returnCode:number) => {
      let isFindIt = false;
      for(let i=0; i<this.messageData.length; i++){
        let item:any = this.messageData[i];
        if(item.uniqueCode != undefined && item.uniqueCode == uniqueCode ){
            if(returnCode == 201){
              isFindIt = true;
              item.msgtatus = 3;
              this.$set(this.messageData, i, item);
              break;
            }else{
              isFindIt = true;
              item.msgtatus = 2;
              this.$set(this.messageData, i, item);
              break;
            }
        }
      }
      if(isFindIt){
        this.$nextTick(()=>{
          this.$forceUpdate();
        });
      }
    };

  }

  /**
   * 发送消息成功的
   */
  onSendMessage(param: GroupMessage) {
    this.messageData.push(param);
    this.$forceUpdate();
    this.$nextTick(() => {
      this.scrollToBottom();
    });
  }

  scrollToBottom() {
    const oDiv: HTMLDivElement = this.$el as HTMLDivElement;
    oDiv.scrollTop = oDiv.scrollHeight;
  }

  setAlreadyRead(groupId: number, id: any) {
    this.wsMsgModule.setAlreadyRead({
      groupId,
      id,
      msgType: 8,
    });
  }

  checkSendStatusFun(){
    for(let i=0; i<this.messageData.length; i++){
        let item:any = this.messageData[i];
        if(item.msgtatus == 1 && item.createTime < (Date.now() - 10*1000)){
          item.msgtatus = 3;
          this.$set(this.messageData, i, item);
        }
    }
    this.$nextTick(()=>{
      this.$forceUpdate();
    });
  }

  //检查消息是否发送成功
  checkSendMsgStatusTimerFun() {
    if(this.checkSendStatusTimer != null){
      clearInterval(this.checkSendStatusTimer);
    }
    //每隔1秒钟进行检查一次
    this.checkSendStatusTimer = setInterval(this.checkSendStatusFun, 1000);
  }

}
